import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { Link } from "react-router-dom";
import { SendPostRequest } from "../../http";
import HeaderWrapper from "../Header/HeaderWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../Spinner";
import FooterWrapper from "../Footer/FooterWrapper";

function MasonryShowcaseGallery() {
  const sitedata = useSelector((store) => store.global.loginData);

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [carouselImages, setCarouselImages] = useState([]);
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getGalleyData();
  }, []);

  const [isData, setIsData] = useState(false);
  const getGalleyData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("gallery/list");
      if (!response?.data || response?.data.length < 1) {
        setIsData(true);
      } else {
        setGalleryData(response.data);
      }
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Gallery" Image="theme-2-banner-gallery.webp"/>

        <div className="container">
          <div className="row portfolio-wrap portfolio-classic-pro py-5 my-2">
            {loading ? (
              <div className="col-12 text-center">
                <Spinner />
              </div>
            ) : galleryData.length > 0 ? (
              galleryData.map((item, index) => (
                <div
                  key={index}
                  className="portfolio-item portfolio-overlay-wrap mansonry-mobile-view-gallery col-lg-4 col-md-4 col-sm-4 col-xs-6"
                >
                  <div className="portfolio-thumb relative">
                     <Link
                            to={`/gallery/${item?.uid}`}>
                    <img
                      src={item.gallery_image}
                      className="img-fluid"
                      alt="gallery thumbnail"
                      style={{ height: "auto", width: "100%" }}
                    />
                    </Link>
                    <div className="portfolio-wrap gallery-mobile-view-overlay">
                      <div className="portfolio-details-overlay typo-white gallery-heading-mob">
                        <h3 className="mb-2">
                          <Link
                            to={`/gallery/${item?.uid}`}
                            rel="noopener noreferrer"
                            className="gallery-head-title"
                          >
                            {item?.gallery_title
                              .split(" ")
                              .slice(0, 10)
                              .join(" ")}
                          </Link>
                        </h3>
                      </div>
                      <div className="portfolio-icons">
                        <Link
                          to={`/gallery/${item?.uid}`}
                          className="link-icon"
                          rel="noopener noreferrer"
                        >
                          <i className="icon-link"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center my-5 py-3">
                <h3>No Record Available</h3>
              </div>
            )}
          </div>
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default MasonryShowcaseGallery;
